/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Comparative_Literature28Inputs */

const en__field__enum_primarystudyinterest_study_comparative_literature28 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Comparative_Literature28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparative Literature`)
};

const de__field__enum_primarystudyinterest_study_comparative_literature28 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Comparative_Literature28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine und vergleichende Literaturwissenschaft`)
};

/**
* | output |
* | --- |
* | "Comparative Literature" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Comparative_Literature28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_comparative_literature28 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Comparative_Literature28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Comparative_Literature28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_comparative_literature28(inputs)
	return de__field__enum_primarystudyinterest_study_comparative_literature28(inputs)
});
export { _field__enum_primarystudyinterest_study_comparative_literature28 as "_field__enum_primaryStudyInterest_STUDY_COMPARATIVE_LITERATURE" }